{
    "CX_Score_Licences_None": "None",
    "CX_Score_Licences_CXSScore": "CX Score Only",
    "CX_Score_Licences_CXSAgent": "CXS Agent",
    "CX_Score_Licences_CXSManager": "CXS Manager",
    "CX_Score_Agent_Error": "An agent is required for a {} subscription",
    "NAME": "CXScoreLanguage"
}
